module.exports = __webpack_public_path__ + "static/media/SunLifeFinancial.c970ebd1.png";